import React, {PropTypes} from 'react';
import moment from 'moment'; 
import ResultsNotFound from '../ResultsNotFound.jsx';
import AuditTeamLedgerDetailContainer from '../teamLedger/AuditTeamLedgerDetailContainer.jsx'; 

const AuditCaptainDetail = ({
  changeDate,
  userEmail,
  audits,
  teamLedgerAudits
}) => (
  <div className="panel panel-primary">
    <div className="panel-heading">
      <div className="alert alert-info text-center">
        <div className="row">
          <div className="col-xs-6">
            <span className="col-xs-12">{'Audit Date'}</span>
            <span><strong>  
              {
                changeDate
                ? `${moment.parseZone(changeDate).format('MMM Do, YYYY, hh:mm:ss A')}`
                : '-'
              }
            </strong></span>
          </div> 
          <div className="col-xs-6">
            <span className="col-xs-12">{'User Email'}</span>
            <span><strong>{userEmail}</strong></span>
          </div> 
        </div> 
      </div> 
    </div>
    <div className="panel-body">
      { audits && audits.length == 0 && teamLedgerAudits && teamLedgerAudits.length == 0 ? <ResultsNotFound/> : null }
      <div className="list-group">
        { audits ? audits.map((item, index) => (
        
        <div className="list-group-item-labeled"
              key={index} > 
          <div className="list-group-item-labeled-child"
            style={{width: 250}}>
            <span>{'Message'}</span>
            <span>{`${item.message}`}</span>
          </div> 
          <div className="list-group-item-labeled-child"
            style={{width: 100}}>
            <span>{'Type'}</span>
            <span>{item.typeName}</span>
          </div>
          <div className="list-group-item-labeled-child"
            style={{width: 100}}>
            <span>{'Property'}</span>
            <span>{item.propertyName}</span>
          </div> 
          <div className="list-group-item-labeled-child"
            style={{width: 150}}>
            <span>{'Original'}</span>
            <span>{item.originalValue}</span>
          </div> 
          <div className="list-group-item-labeled-child"
            style={{width: 150}}>
            <span>{'Current Value'}</span>
            <span>{item.currentValue}</span>
          </div>  
        </div>
          )) : null}
      </div>
      <AuditTeamLedgerDetailContainer details={teamLedgerAudits} />
    </div>
  </div>   
);

AuditCaptainDetail.propTypes = {
  changeDate: PropTypes.string,
  userEmail: PropTypes.string,
  audits: PropTypes.arrayOf(PropTypes.object),
  teamLedgerAudits: PropTypes.arrayOf(PropTypes.object)
};

AuditCaptainDetail.defaultProps = {
};

export default AuditCaptainDetail;



// WEBPACK FOOTER //
// ./src/features/admin/audit/captainAudit/AuditCaptainDetail.jsx